import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, mergeMap } from 'rxjs/operators';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { OrdAllocateActions } from './ord-allocate.actions';
import { OrdAllocateI } from 'src/app/api/ord-allocate/ord-allocate.result.int';
import { OrdFiltersActions } from '../ord-filters/ord-filters.actions';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { Store } from '@ngrx/store';

@Injectable()
export class OrdAllocateEffects {
    // Injects
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdAllocateActions.load),
        mergeMap((action) => from(this.sharedGenericService.invoke(ApiOrdMethod.ordAllocate, action.query))
            .pipe(
                mergeMap((result: OrdAllocateI) => {
                    const actionsToReturn: any[] = [
                        OrdAllocateActions.received({
                            result
                        }),
                    ];
                    if (result.allocatedSuccesfully === true || result.allocatedSuccesfully === null) {
                        actionsToReturn.push(spxToasterActions.createSuccess({ messageText: `Allocated`, autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT, }));
                        actionsToReturn.push(OrdFiltersActions.update({}));
                    } else {
                        actionsToReturn.push(spxToasterActions.createWarning({ messageText: `Not allocated, already allocated to someone else`, autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT, }));
                    }
                    return actionsToReturn;
                }),
                catchError((error) => {
                    console.error(error);
                    return [
                        OrdAllocateActions.error({
                            error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdAllocateActions.error),
        mergeMap((action) => [
            spxToasterActions.createError({
                messageText: `Error in allocation`,
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
            }),
        ]))
    );

}
